import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $createParagraphNode, $getRoot } from "lexical";
import { useEffect, type FC } from "react";

export const ClickToAppendPlugin: FC = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerRootListener((rootElement) => {
      if (rootElement !== null) {
        const onMouseUp = (event: MouseEvent): void => {
          // 1. Get the browser selection
          const selection = window.getSelection();

          // 2. Only proceed if the click was on the root AND the user isn't highlighting text
          // (selection.isCollapsed is true when no text is highlighted)
          if (event.target === rootElement && selection?.isCollapsed) {
            editor.update(() => {
              const root = $getRoot();
              const lastChild = root.getLastChild();

              if (
                lastChild === null ||
                lastChild.getTextContentSize() > 0 ||
                lastChild.getType() !== "paragraph"
              ) {
                const p = $createParagraphNode();
                root.append(p);
                p.select();
              } else {
                lastChild.selectEnd();
              }
            });
          }
        };

        // Use mouseup instead of click to better handle the end of a drag
        rootElement.addEventListener("mouseup", onMouseUp);
        return () => rootElement.removeEventListener("mouseup", onMouseUp);
      }
    });
  }, [editor]);

  return null;
};
